// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"about-us_Wrapper__ALSsi","Content":"about-us_Content__C_krU"};